/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_ButtonInputs */

const en_settings_tickets_create_button = /** @type {(inputs: Settings_Tickets_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Ticket`)
};

const zh_settings_tickets_create_button = /** @type {(inputs: Settings_Tickets_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工单`)
};

/**
* | output |
* | --- |
* | "New Ticket" |
*
* @param {Settings_Tickets_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_button = /** @type {((inputs?: Settings_Tickets_Create_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_create_button(inputs)
	return zh_settings_tickets_create_button(inputs)
});
export { settings_tickets_create_button as "settings.tickets.create_button" }